import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
import type { Feature } from '../data/howItWorks';
type FeatureSectionProps = {
  id?: string;
  label: string;
  title: string;
  body: string;
  features: Feature[];
  alt?: boolean;
  columns?: 2 | 3;
};
export function FeatureSection({
  id,
  label,
  title,
  body,
  features,
  alt = false,
  columns = 2
}: FeatureSectionProps) {
  return <section id={id} className={`relative isolate overflow-hidden border-b border-[#1a1a1a] ${alt ? 'bg-[#0c0c0c]' : ''}`} data-id="element-223" data-mp="21eh75fbgw602">
      <Bloom size="md" className="left-0 top-[-6rem]" data-id="element-224" data-mp="2ae4ai6nrblvr" />
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-24" data-id="element-225" data-mp="2fbvyipla6nuo">
        <SectionLabel data-id="element-226" data-mp="2fb4du9t82aj6">{label}</SectionLabel>
        <h2 className="mt-8 max-w-2xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-227" data-mp="fzbfo9up6z4v">
          {title}
        </h2>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-228" data-mp="kyekbt6rn3cb">{body}</p>

        <ul className={`mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-[#1c1c1c] bg-[#1c1c1c] ${columns === 3 ? 'sm:grid-cols-3' : 'sm:grid-cols-2'}`} data-id="element-229" data-mp="2irfm7mbjch9t">
          {features.map((f, i) => <motion.li key={f.title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className={`p-8 ${alt ? 'bg-[#0d0d0d]' : 'bg-[#0a0a0a]'}`} data-id="element-230" data-mp="24ziydugwgtj8" data-mpi={i}>
              <h3 className="text-base font-semibold text-white" data-id="element-231" data-mp="2sn0id3txanbn">{f.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-232" data-mp="2noyzaiwhyo06">{f.body}</p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}